// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--3qeSg","pagination":"pagination--1lsb2"};